
<template>
    <v-touch class="carousel flex-nowrap" v-on:swipeleft="nextSlide" v-on:swiperight="previousSlide">

        <div class="d-flex">

            <div class="carousel-navigation d-flex align-items-center pointer z-index-top h-75" :class="hiddenDesktop ? 'hidden-lg-up' : ''" @click="previousSlide">
                <span class="icon-left-open-big" :class="buttonslide ? 'button-slide' : ''"></span>
            </div>

            <div class="mx-0 mw-sm-75">
                <div class="carousel-slides-container row flex-nowrap hide-overflow">
                    <slot></slot>
                </div>
            </div>

            <div class="carousel-navigation d-flex align-items-center pointer z-index-top h-75" :class="hiddenDesktop ? 'hidden-lg-up' : ''" @click="nextSlide">
                <span class="icon-right-open-big" :class="buttonslide ? 'button-slide' : ''"></span>
            </div>

        </div>

    </v-touch>
</template>

<script>
    export default {
        props: {
            hiddenDesktop: {
            	type: Boolean,
                default: true
            },
          buttonslide: {
            	type: Boolean,
                default: false
          }
        },

        data: function () {
            return {
                moving: false,
                slidesContainer: null,
            }
        },

        mounted: function () {
            this.slidesContainer = $( this.$el ).find( '.carousel-slides-container' );
        },

        methods: {
            previousSlide: function () {
                if ( this.moving ) return;

                this.moving = true;
                $( this.$el ).find( '.carousel-slide:last' ).prependTo( this.slidesContainer );
                $( this.$el ).find( '.carousel-slide' ).addClass( 'at-left' );

                setTimeout( () => {
                    $( this.$el ).find( '.carousel-slide' ).addClass( 'transitioning' );
                    $( this.$el ).find( '.carousel-slide' ).removeClass( 'at-left' );

                    setTimeout( () => {
                        $( this.$el ).find( '.carousel-slide' ).removeClass( 'transitioning' );
                        this.moving = false;
                    }, 500 );

                }, 0);
            },

            nextSlide: function () {
                if ( this.moving ) return;

                this.moving = true;
                $( this.$el ).find( '.carousel-slide' ).addClass( 'to-left' );

                setTimeout( () => {
                    $( this.$el ).find( '.carousel-slide:first' ).appendTo( this.slidesContainer );
                    $( this.$el ).find( '.carousel-slide' ).removeClass( 'to-left' );
                    this.moving = false;
                }, 500 );
            },
        }
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    .carousel-slides-container {
        max-width: 1425px;
    }

    .carousel {

        .carousel-slide {
            position: relative;
            transform: translate3d( 0, 0, 0 );

            &.to-left {
                transform: translate3d( -100%, 0, 0 );
                transition: transform 0.4s;
            }
            &.at-left {
                transform: translate3d( -100%, 0, 0 );
            }
            &.transitioning {
                transition: transform 0.4s;
            }
        }

        .carousel-navigation:hover {
            background-color: #ffffff4d;
        }
    }

    .pointer {
        cursor: pointer;
    }

    .button-slide {
        background-color: #636363;
        border-radius: 50px;
        margin: 5px;
        height: 40px;
        color: white;
        padding: 10px 6px 5px 5px;

        &:hover {
            opacity: 0.5;
        }

        &:active, &:focus {
            opacity: 0.8;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Carousel.vue